module.exports = __webpack_public_path__ + "img/category-management-icon5.824a8c80.svg";